<template>
  <div class="kt-header__topbar-item" v-on="$listeners">
    <div class="kt-header__topbar-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'NavbarMainItem'
}
</script>
